import { useTranslation } from 'react-i18next'
import { Badge, Checkbox } from '@/components/ui'

interface RolloverConfirmationProps {
  usage: number
  confirmed?: boolean
  onConfirm?: (confirmed: boolean) => void
}

export function RolloverConfirmation({ usage, confirmed = false, onConfirm }: RolloverConfirmationProps) {
  const { t } = useTranslation('meters')
  return (
    <div className="flex flex-col items-start gap-2" aria-live="polite">
      <Badge variant="warning">{t('rollover.badge', { usage })}</Badge>
      {onConfirm && (
        <Checkbox
          size="sm"
          checked={confirmed}
          onChange={(event) => onConfirm(event.target.checked)}
          label={t('rollover.confirm')}
        />
      )}
    </div>
  )
}
